module.exports = __webpack_public_path__ + "static/media/Trezar_White.4af51498.png";